import { useContext } from 'react';
import { Label as BaseLabel } from '@visx/annotation';
import DataContext from "../../context/DataContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
const defaultBackgroundProps = {
  fillOpacity: 0.7
};

/** AnnotationLabel which provides text styles from theme. */
export default function AnnotationLabel(props) {
  const {
    theme,
    resizeObserverPolyfill
  } = useContext(DataContext);
  const titleProps = theme?.svgLabelBig;
  const subtitleProps = theme?.svgLabelSmall;
  return /*#__PURE__*/_jsx(BaseLabel, {
    anchorLineStroke: theme?.axisStyles.x.bottom.axisLine.stroke,
    backgroundFill: theme?.backgroundColor,
    backgroundProps: defaultBackgroundProps,
    showAnchorLine: true,
    subtitleFontSize: subtitleProps?.fontSize,
    subtitleFontWeight: subtitleProps?.fontWeight,
    subtitleProps: subtitleProps,
    titleFontSize: titleProps?.fontSize,
    titleFontWeight: titleProps?.fontWeight,
    titleProps: titleProps,
    resizeObserverPolyfill: resizeObserverPolyfill,
    ...props
  });
}